/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {BookingDetailUpload} from '../../../../models/booking.model'
import {getListBulkLoadTrayService} from '../../../../services/booking.service'
import {ModalDetailBooking} from '../../../bookings/components/Modals/ModalDetailBooking'

const TableCheckOutSummary: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const [showModal, setShowModal] = useState(false)
  const [bookingtoShow, setBookingToShow] = useState<BookingDetailUpload | any>(null)
  const {currentTabItem} = useHoteleria()
  const getUploadBookings = async () => {
    try {
      setLoading(true)
      const {data: response} = await getListBulkLoadTrayService({
        TipoBandeja: 'COU',
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUploadBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleShowDetail = (item: BookingDetailUpload) => {
    setBookingToShow(item)
    setShowModal(true)
  }
  useEffect(() => {
    if (currentTabItem.trayUpdated) {
      getUploadBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.trayUpdated])

  const columns: Column<BookingDetailUpload>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Archivo' />,
      accessor: 'NombreArchivo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Bandeja' />,
      accessor: 'TipoBandeja',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros cargados' />,
      accessor: 'RegistrosProcesados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros aceptados' />,
      accessor: 'RegistrosAceptados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros rechazados' />,
      accessor: 'RegistrosRechazados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de carga' />,
      accessor: 'FechaHoraCarga',
      Cell: ({...props}) => (
        // <div>{moment(props.row.original.uploadedDate).local().format('DD/MM/YYYY HH:mm')}</div>
        <div>{moment(props.row.original.FechaHoraCarga).local().format('DD/MM/YYYY HH:mm:ss')}</div>
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions_ver',
      Cell: ({...props}) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleShowDetail(props.row.original)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalDetailBooking
          show={showModal}
          setShow={setShowModal}
          bookingToShow={bookingtoShow}
          title='Detalle de Checkout Masivo'
        />
      </KTCard>
    </>
  )
}

const TableCheckOutSummaryWrapper = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  //   let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <KTableProvider>
      <ButtonClose onClick={handleBack} color='#283897' />
      <TableCheckOutSummary />
    </KTableProvider>
  )
}

export {TableCheckOutSummaryWrapper}
